import { BaleTypeEnum } from "@gtpl/shared-models/common-models";
import { Column, CreateDateColumn, Entity, OneToMany, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { WorkOrderItems } from "./work-order-items.entity";

@Entity('work_order_info')
export class WorkOrderInfo {

    @PrimaryGeneratedColumn("increment", { name: 'id' })
    id: number;

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        name: "created_user",
        length: 50
    })
    createdUser: string | null;

    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user",
        length: 50
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

    @Column("boolean", {
        nullable: false,
        default: true,
        name: "is_active"
    })
    isActive: boolean;

    @Column('varchar',{
        name:'work_order_no',
        length:30,
        nullable:false
    })
    workOrderNo: string  

    @Column('datetime',{
        name:'work_order_date',
        nullable:false
    })
    workOrderDate : Date

        @Column("int", {
        nullable: false,
        default: true,
        name: "plant_id"
    })
    plantId: number;

        @Column('varchar',{
        name:'remarks',
        length:30,
        nullable:false
    })
    remarks: string

 

        @OneToMany(type => WorkOrderItems, workOrderItems => workOrderItems.workOrderInfo, { cascade: true })
    workOrderItems: WorkOrderItems[];

}